import { useLearningStatsOverallPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.stats.overall.navigator";
import { useLearningStatsSentencesPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.stats.sentences.navigator";
import type { LearningStatsTab } from "#learning-stats-toolbar";
import { useCallback } from "react";

/**
 * Maps a Stats toolbar tab pill to navigation. Each pill replaces the current Stats route on the
 * press; the destination draws its own skeleton (or sync placeholder) while its data loads.
 */
export function useLearningStatsToolbarNavigation() {
  // Depend on each navigator's `mutate`, which TanStack keeps stable. The navigator objects (and
  // their `replace` mutation results) are rebuilt on every render, so a callback keyed on them
  // changed identity on every render too and re-rendered every toolbar pill with it — including
  // on each bottom-tab switch, when this toolbar is not even on screen.
  const replaceWithOverall = useLearningStatsOverallPageNavigator().replace.mutate;
  const replaceWithSentences = useLearningStatsSentencesPageNavigator().replace.mutate;

  return useCallback(
    (tab: LearningStatsTab) => {
      if (tab === "sentences") {
        replaceWithSentences();
        return;
      }
      replaceWithOverall();
    },
    [replaceWithOverall, replaceWithSentences],
  );
}
